import React from 'react';
import UpdateParentWindow from "./update-parent-window/Updater.js";

class ImplementationModel extends React.Component {

  constructor(props) {
    super(props);
    this.animToggleTimer = [];
    this.toggleAnimDuration = 250;
    this.state = {
      curCard: null,
      curTab: null,
      toggling: false
    };
  }

  selectImplementationModel(im) {
    let selectedModel = this.props.state.implementationModel && this.props.state.implementationModel === im ? null : im;
    this.props.selectImplementationModel({implementationModel: selectedModel})
  };

  toggleSection(e, key, cardId) {
    e.stopPropagation();
    if(this.animToggleTimer[key]) clearTimeout(this.animToggleTimer[key]);
    if(this.state.curTab === key) {
      this.setState({curTab: null, cardId: null});
    } else {
      this.setState({curTab: key, cardId: cardId});
    }
    setTimeout(() => {
        this.setState({toggling: true});
    },20);
    this.animToggleTimer[key] = setTimeout(() => {
      this.setState({toggling: false});
      UpdateParentWindow(this.props.state, this.props.selectImplementationModel);
      clearTimeout(this.animToggleTimer[key]);
    }, this.toggleAnimDuration);
  }

  render() {
    return (
      <div className="card-wrapper">
        {this.props.selected}
        <div
          className={"card" + ((this.props.selected) ? " selected" : "")}
          tabIndex="0"
          aria-label={"Valitse " + this.props.model.title}
          onClick={() => {this.selectImplementationModel(this.props.model.slug);}}>
          <span className="title">{this.props.model.title}</span>
          <span className="description">{this.props.model.description}</span>
          <div className="card-tabs">
            {this.props.model.use_cases ?
              <div className={"card-tab" +
                (this.state.curTab === 'use-cases' && this.props.model.slug === this.state.cardId ? " card-tab--active" : "")}
                onClick={(e) => {this.toggleSection(e, 'use-cases', this.props.model.slug)}}>
                Käyttökohteet
              </div>
              : null
            }
            {this.props.model.benefits_and_risks ?
              <div className={"card-tab" +
                (this.state.curTab === 'risks' && this.props.model.slug === this.state.cardId ? " card-tab--active" : "")}
                onClick={(e) => {this.toggleSection(e, 'risks', this.props.model.slug)}}>
                Ominaisuudet
              </div>
              : null
            }
          </div>
        </div>
        {this.props.model.use_cases ?
          <div className={"card-tab-content" +
            (this.state.curTab === 'use-cases' && this.props.model.slug === this.state.cardId ? " card-tab-content--open" : "") +
            (this.state.toggling ? " card-tab-content--toggling" : "")}
            style={{transitionDuration: this.toggleAnimDuration + "ms"}}
            dangerouslySetInnerHTML={{ __html: this.props.model.use_cases }}>
          </div>
        :null}
        {this.props.model.benefits_and_risks ?
          <div className={"card-tab-content card-tab-content--img" +
            (this.state.curTab === 'risks' && this.props.model.slug === this.state.cardId ? " card-tab-content--open" : "") +
            (this.state.toggling ? " card-tab-content--toggling" : "")}
            style={{transitionDuration: this.toggleAnimDuration + "ms"}}>
            <img
              src={this.props.model.benefits_and_risks}
              alt="Ominaisuudet taulukko"
              onClick={(e) => {
                e.persist();
                this.props.selectImplementationModel({imageZoom:{img:this.props.model.benefits_and_risks,e:e}})}
              } />
          </div>
        :null}
      </div>
    );
  }
}

export default ImplementationModel;
